import i18n from "i18n";

const columns = [
    {
      name: 'name',
      pill: false,
      title: i18n.t("name").toUpperCase(),
      mobileTag: false,
    },
    {
      name: 'document',
      pill: false,
      title: i18n.t("document").toUpperCase(),
      mobileTag: 'Documento:',

    },
    {
      name: 'country',
      pill: false,
      title: i18n.t("country").toUpperCase(),
      mobileTag: 'Pais:',

    },
    {
      name: 'region',
      pill: false,
      title: i18n.t("community").toUpperCase(),
      mobileTag: 'Comunidad:',

    },

    {
      name: 'state',
      pill: false,
      title: i18n.t("province").toUpperCase(),
      mobileTag: 'Provincia:',

    },
    {
      name: 'locality',
      pill: false,
      title: i18n.t("municipality").toUpperCase(),
      mobileTag: 'Municipio:',

    },
  ];


  export default columns;